import { sync } from 'vuex-router-sync';
import Vue from 'vue';
import App from './App.vue';

/**
 * The Vuex store is available to all components
 */
import store from './store';

/**
 * The router runs components defined by request URL
 */
import router from './router';

/**
 * $http plugin based on axios
 */
import http from './plugins/http';

/**
 * $bus plugin for global event bus
 */
import eventbus from './plugins/eventbus';

/**
 * Make $http available to all components
 */
Vue.use(http, { store, router });

/**
 * Make $bus available to all components
 */
Vue.use(eventbus);

//-- --------- Bootstrap-Vue --------- --//

import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);

//-- --------- Calendar --------- --//

import FullCalendar from 'vue-full-calendar';
Vue.use(FullCalendar);

//-- --------- Sweet Alert 2 --------- --//

import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

//-- --------- Datetimepicker --------- --//

global.moment = require('moment');
require('tempusdominus-bootstrap-4');

//-- --------- VueDraggable Drag & Drop --------- --//
import VueDraggable from 'vue-draggable';

Vue.use(VueDraggable);

/**
 * Handle events based on css classes
 */
import './plugins/css-class-events';

// TODO import dropzone itself here as well?
//-- --------- Vue Dropzone CSS file --------- --//
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

//-- --------- Style composition --------- --//

import './style';

//-- --------- Material Icons --------- --//

import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/outlined.css';

//-- --------- Register Filters --------- --//

import * as Filters from './services/AppFilters';

Object.keys(Filters.default).forEach((filter) => {
    Vue.filter(filter, Filters.default[filter]);
});

//-- --------- Register Directives --------- --//

import './services/Directives';

//-- --------- Global Mixins --------- --//

import Mixins from './services/AppMixins';

Vue.mixin(Mixins);

// Keep vue-router and vuex store synced
sync(store, router);

Vue.prototype.$isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

// Start application
/* eslint-disable no-new */
new Vue({

    el: '#app',
    store,
    router,
    template: '<App/>',
    components: {App}

});



// WEBPACK FOOTER //
// ./src/main.js